/**
 * ModularProfileRedirect Component
 * 
 * This component handles redirects from the old query parameter-based URLs
 * to the new RESTful path-based URLs. It maintains backward compatibility
 * during the transition period.
 */

import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Center, Spinner, Text, VStack } from '@chakra-ui/react';

const ModularProfileRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Parse the query parameters
    const params = new URLSearchParams(location.search);
    const section = params.get('section');
    const game = params.get('game');
    const cardType = params.get('cardType');
    const mode = params.get('mode');
    
    // Determine the new RESTful URL based on the query parameters
    let newUrl = '/';
    
    if (section === 'games') {
      newUrl = '/games';
      
      if (game === 'scratchCard') {
        newUrl = '/games/scratch-cards';
        
        if (cardType) {
          newUrl = `/games/scratch-cards/${cardType}`;
          
          // If in creator mode, redirect to edit page
          if (mode === 'creator') {
            newUrl = `/games/scratch-cards/${cardType}/edit`;
          }
        } else if (mode === 'creator') {
          // If in creator mode without a specific card type, redirect to create page
          newUrl = '/games/scratch-cards/create';
        }
      }
    } else if (section) {
      // Handle other sections
      newUrl = `/${section.toLowerCase()}`;
    }
    
    // Redirect to the new URL
    navigate(newUrl, { replace: true });
  }, [location, navigate]);
  
  return (
    <Box height="100vh" width="100%" bg="gray.900">
      <Center height="100%">
        <VStack spacing={4}>
          <Spinner size="xl" color="blue.500" thickness="4px" speed="0.65s" />
          <Text color="white" fontSize="lg">Redirecting to new URL structure...</Text>
        </VStack>
      </Center>
    </Box>
  );
};

export default ModularProfileRedirect;
